// TODO: выпилить, когда появятся дополнительные переменные
// eslint-disable-next-line import/prefer-default-export
export const NARROW_COLUMN_STYLES = {
    padding: '0.625rem 0.1rem 0.625rem 0.1rem',
    width: '30px',
};
